<template>
  <div class="dash-card" :class="classes">
    <div v-if="title" class="dash-card__header">
      <span class="dash-card__title">{{ title }}</span>
      <div class="dash-card__divider"></div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    title: { type: String, default: null },
    accent: { type: Boolean, default: false },
    noPad: { type: Boolean, default: false },
  },
  computed: {
    classes () {
      return {
        'dash-card--accent': this.accent,
        'dash-card--no-pad': this.noPad,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dash-card {
  background: #1D1D29;
  border-radius: 16px;
  padding: 20px;

  &--accent {
    border-top: 3px solid var(--v-primary-base);
  }

  &--no-pad {
    padding: 0;
  }

  &__header {
    margin-bottom: 16px;
  }

  &__title {
    font-size: 15px;
    font-weight: 600;
    color: #C7C7D8;
    display: block;
    margin-bottom: 6px;
  }

  &__divider {
    width: 45px;
    height: 2px;
    background: var(--v-primary-base);
    border-radius: 1px;
  }
}
</style>
